<template>
    <div class="field is-horizontal">
        <div class="field-label">
            <label class="label">Your Bid:</label>
        </div>
        <div class="field-body">
            <div class="field has-addons">
                <div class="control">
                    <input class="input" type="number" @input="isTypingYen = true" placeholder="Place your bid" v-model="amountYen">
                </div>
                <p class="control">
                    <a class="button is-static">
                        000 ¥
                    </a>
                </p>
                <div class="control">
                    <input class="input" type="number" @input="isTypingUsd = true" placeholder="Place your bid" v-model="amountUsd">
                </div>
                <p class="control">
                    <a class="button is-static">
                        $
                    </a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import { debounce } from 'debounce';
    export default {
        data() {
            return {
                isTypingYen: false,
                isTypingUsd: false,
            }
        },
        computed: {
            amountYen: {
                get() {
                    return this.$store.getters.getResultActiveBiddingModalBidAmountYen
                },
                set(value) {
                    this.$store.dispatch('changeResultBiddingModalBidAmountYen', value)
                }
            },
            amountUsd: {
                get() {
                    return this.$store.getters.getResultActiveBiddingModalBidAmountUsd
                },
                set(value) {
                    this.$store.dispatch('changeResultBiddingModalBidAmountUsd', value)
                }
            }
        },
        watch: {
            amountYen:  debounce(function() {
                this.isTypingYen = false
            }, 1000),
            isTypingYen: function(value) {
                if (!value) {
                    this.$store.dispatch('convertResultBiddingModalBidAmountYenToUsd')
                }
            },
            amountUsd: debounce(function() {
                this.isTypingUsd = false
            }, 1000),
            isTypingUsd: function(value) {
                if (!value) {
                    this.$store.dispatch('convertResultBiddingModalBidAmountUsdToYen')
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Auctions/Advance/BiddingModal/Inputs/BidInput.vue